import {defaultTheme, textSizes} from '@stencil/build-theme';

//Components
import RefundTimelineBar from '../RefundTimelineBar';

//Icons
import HappyTickMarkIcon from '@stencil/icons/src/HappyTickMarkIcon/HappyTickMarkIcon';

//styles
import * as S from './FCCancellationPolicyTimeline.styles';

const FCCancellationPolicyTimeline = ({cancellationPolicyTimeline}) => {
  const {freeCancellationBenefits, timeline, title} = ({} = cancellationPolicyTimeline);
  return (
    <S.FCCancellationPolicyTimelineWrapper>
      {/* {freeCancellationBenefits?.length && (
        <ul className="appendBottom12">
          {freeCancellationBenefits.map((benefit, index) => {
            const {iconType, text} = benefit;
            return (
              <li className="makeFlex hrtlCenter appendBottom3" key={index}>
                {iconType == 'SINGLETICK' && (
                  <HappyTickMarkIcon
                    height="1rem"
                    width="1rem"
                    margin="0 0.8rem 0 0"
                    fill={defaultTheme.colors.goGreen.base}
                  />
                )}
                {text ? (
                  <p
                    style={{
                      ...textSizes.SmallW1,
                    }}
                    dangerouslySetInnerHTML={{__html: text}}
                  />
                ) : null}
              </li>
            );
          })}
        </ul>
      )} */}
      <div className={`fcDetails`}>
        <RefundTimelineBar timeline={timeline} />
      </div>
    </S.FCCancellationPolicyTimelineWrapper>
  );
};
export default FCCancellationPolicyTimeline;
